import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./TrustCenterPage.css";
import Logo from "../img/logo.png";
import bgImage from "../img/blog_background.png";
import { useNavigate, useLocation } from "react-router-dom";

import berlin from '../img/company/berlin.png'
import esf from '../img/company/esf.jpg'
import hwr from '../img/company/hwr.png'
import sib from '../img/company/sib.jpg'

function TrustCenterPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay for page to render
    } else {
      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>Trust Center - Revexia | Security & Privacy</title>
        <meta
          name="description"
          content="Your data, privacy, and security are foundational to how Revexia is built. Learn about our security infrastructure and compliance."
        />
      </Helmet>

      <div className="trust-center-page">
        {/* Navigation */}
         <nav className="navbar-custom">
          <div className="navbar-container">
            {/* Logo Section */}
            <div className="navbar-brand-custom">
              <Link to="/">
                <img src={Logo} alt="Revexia Logo" className="navbar-logo-img" />
              </Link>
            </div>

            {/* Center Navigation Pills */}
            <div className="navbar-center-pill">
              <ul className="nav-menu-pills">
                <li className="nav-item-pill">
                  <Link to="/" className="nav-link-pill">
                    Home
                  </Link>
                </li>
                <li className="nav-item-pill">
                  <a href="/#features" className="nav-link-pill" onClick={handleClick}>
                    Feature
                  </a>
                </li>

                <li className="nav-item-pill nav-item-dropdown">
                  <button className="nav-link-pill nav-dropdown-toggle">
                    Resources
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="dropdown-arrow"
                    >
                      <path
                        d="M1 1L5 5L9 1"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div className="nav-dropdown-menu">
                    <Link to="/how" className="nav-dropdown-item">
                      How it works
                    </Link>
                    <Link to="/support" className="nav-dropdown-item">
                      Support overview
                    </Link>
                    <Link to="/trust" className="nav-dropdown-item">
                      Trust Center
                    </Link>
                    <Link to="/privacy-policy" className="nav-dropdown-item">
                      Privacy Policy
                    </Link>
                    <Link to="/terms" className="nav-dropdown-item">
                      Terms of Service
                    </Link>
                     <Link to="/facebook-terms" className="nav-dropdown-item">
                                          Facebook Terms
                                        </Link>
                  </div>
                </li>
                <li className="nav-item-pill">
                  <Link to="/blog" className="nav-link-pill">
                    Blog
                  </Link>
                </li>
                
              </ul>
            </div>

            {/* Right Side - Auth Buttons */}
            <div className="navbar-auth-section">
              {user ? (
                <>
                  <Link to="/dashboard" className="btn-nav-outline">
                    Dashboard
                  </Link>
                  <button onClick={handleLogout} className="btn-nav-gradient">
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/join-waitlist" className="btn-nav-gradient">
                                     Get Started
                                   </Link>
                                     <Link to="/auth" className="btn-nav-gradientlogin">
                                     Login
                                   </Link>
                </>
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="navbar-mobile-toggle"
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="navbar-toggler-icon-custom"></span>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="navbar-mobile-menu">
              <ul className="mobile-nav-list">
                <li>
                  <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                    Home
                  </Link>
                </li>

                <li >
                  <a href="/#features" onClick={(e) => {
                      setMobileMenuOpen(false);
                      handleClick(e);
                    }} >
                    Feature
                  </a>
                </li>
                
                <li>
                  <Link to="/how" onClick={() => setMobileMenuOpen(false)}>
                    How it works
                  </Link>
                </li>
                <li>
                  <Link to="/support" onClick={() => setMobileMenuOpen(false)}>
                    Support overview
                  </Link>
                </li>
                <li>
                  <Link to="/trust" onClick={() => setMobileMenuOpen(false)}>
                    Trust Center
                  </Link>
                </li>
                <li>
                  <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>
                    Blog
                  </Link>
                </li>
                
              </ul>
              <div className="mobile-auth-buttons">
                {user ? (
                  <>
                    <Link
                      to="/dashboard"
                      className="btn-nav-outline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Dashboard
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setMobileMenuOpen(false);
                      }}
                      className="btn-nav-gradient"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/auth"
                      className="btn-nav-gradient"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Login
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>

        {/* Main Content */}
        <main className="trust-center-main">
          {/* Hero Section with Background */}
          <section className="trust-hero-section">
            {/* Background Effects */}
            <div className="trust-hero-bg-effects">
              <div className="trust-hero-bg-image-wrapper">
                <img src={bgImage} alt="" className="trust-hero-bg-image" />
              </div>
              <div className="trust-hero-gradient-overlay"></div>
            </div>

            {/* Hero Content */}
            <div className="trust-hero-content">
              <h1 className="trust-hero-title">Trust Center</h1>
              <p className="trust-hero-subtitle">
                Your data, privacy, and security are foundational to how Revexia
                is built.
              </p>
            </div>
          </section>

          {/* Data Principles Section */}
          <section className="trust-principles-section">
            <div className="trust-principles-container">
              <div className="trust-principles-grid">
                {/* Principle 1 */}
                <div className="trust-principle-card">
                  <div className="trust-principle-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 2L9 6V12C9 18.075 12.84 23.64 16 25C19.16 23.64 23 18.075 23 12V6L16 2Z"
                        stroke="#60A5FA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13 16L15 18L19 14"
                        stroke="#60A5FA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h3 className="trust-principle-title">You Own Your Data</h3>
                  <p className="trust-principle-description">
                    Your data always belongs to you — not Revexia.
                  </p>
                </div>

                {/* Principle 2 */}
                <div className="trust-principle-card">
                  <div className="trust-principle-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="6"
                        y="6"
                        width="20"
                        height="20"
                        rx="2"
                        stroke="#60A5FA"
                        strokeWidth="2"
                      />
                      <path
                        d="M16 10V22M10 16H22"
                        stroke="#60A5FA"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <h3 className="trust-principle-title">
                    Purpose-Limited Processing
                  </h3>
                  <p className="trust-principle-description">
                    Revexia processes data only to provide the service — nothing
                    more.
                  </p>
                </div>

                {/* Principle 3 */}
                <div className="trust-principle-card">
                  <div className="trust-principle-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="16"
                        cy="10"
                        r="4"
                        stroke="#60A5FA"
                        strokeWidth="2"
                      />
                      <path
                        d="M8 26C8 21.5817 11.5817 18 16 18C20.4183 18 24 21.5817 24 26"
                        stroke="#60A5FA"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <path
                        d="M20 10L22 12L26 8"
                        stroke="#60A5FA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h3 className="trust-principle-title">
                    Permission-Based Access
                  </h3>
                  <p className="trust-principle-description">
                    Access is strictly permission-based and can be revoked at any
                    time.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* GDPR Compliance Section */}
          <section className="trust-gdpr-section">
            <div className="trust-gdpr-container">
              <h2 className="trust-gdpr-title">
                GDPR & Global Privacy Compliance
              </h2>
              <p className="trust-gdpr-subtitle">
                Revexia is designed to comply with major global privacy
                regulations.
              </p>

              <div className="trust-gdpr-badges">
                <div className="gdpr-badge">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 2L4 5V9C4 13.55 7.84 17.74 10 18.5C12.16 17.74 16 13.55 16 9V5L10 2Z"
                      stroke="#60A5FA"
                      strokeWidth="1.5"
                    />
                  </svg>
                  <span>GDPR (EU)</span>
                </div>

                <div className="gdpr-badge">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 2L4 5V9C4 13.55 7.84 17.74 10 18.5C12.16 17.74 16 13.55 16 9V5L10 2Z"
                      stroke="#60A5FA"
                      strokeWidth="1.5"
                    />
                  </svg>
                  <span>UK GDPR</span>
                </div>

                <div className="gdpr-badge">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 2L4 5V9C4 13.55 7.84 17.74 10 18.5C12.16 17.74 16 13.55 16 9V5L10 2Z"
                      stroke="#60A5FA"
                      strokeWidth="1.5"
                    />
                  </svg>
                  <span>CCPA / CPRA</span>
                </div>

                <div className="gdpr-badge">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 2L4 5V9C4 13.55 7.84 17.74 10 18.5C12.16 17.74 16 13.55 16 9V5L10 2Z"
                      stroke="#60A5FA"
                      strokeWidth="1.5"
                    />
                  </svg>
                  <span>PIPEDA</span>
                </div>

                <div className="gdpr-badge">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 2L4 5V9C4 13.55 7.84 17.74 10 18.5C12.16 17.74 16 13.55 16 9V5L10 2Z"
                      stroke="#60A5FA"
                      strokeWidth="1.5"
                    />
                  </svg>
                  <span>Australian Privacy Act</span>
                </div>
              </div>
            </div>
          </section>

          {/* Security Infrastructure Section */}
          <section className="trust-security-section">
            <div className="trust-security-container">
              <h2 className="trust-section-title">Security Infrastructure</h2>

              <div className="trust-security-card">
                <div className="trust-security-items">
                  {/* Security Item 1 */}
                  <div className="trust-security-item">
                    <div className="trust-security-icon">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="8"
                          y="12"
                          width="24"
                          height="20"
                          rx="2"
                          stroke="#E5E7EB"
                          strokeWidth="2"
                        />
                        <path
                          d="M12 12V10C12 7.79086 13.7909 6 16 6H24C26.2091 6 28 7.79086 28 10V12"
                          stroke="#E5E7EB"
                          strokeWidth="2"
                        />
                        <circle cx="20" cy="22" r="3" stroke="#E5E7EB" strokeWidth="2" />
                      </svg>
                    </div>
                    <div className="trust-security-content">
                      <h3 className="trust-security-title">
                        Encrypted Data Storage
                      </h3>
                      <p className="trust-security-description">
                        All data is securely encrypted at rest using
                        industry-standard AES-256 encryption.
                      </p>
                    </div>
                  </div>

                  {/* Security Item 2 */}
                  <div className="trust-security-item">
                    <div className="trust-security-icon">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="20" cy="20" r="14" stroke="#E5E7EB" strokeWidth="2" />
                        <path
                          d="M12 20H28M20 12V28"
                          stroke="#E5E7EB"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div className="trust-security-content">
                      <h3 className="trust-security-title">
                        Secure API Connections
                      </h3>
                      <p className="trust-security-description">
                        All integrations use secure API connections over
                        HTTPS/TLS 1.3.
                      </p>
                    </div>
                  </div>

                  {/* Security Item 3 */}
                  <div className="trust-security-item">
                    <div className="trust-security-icon">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 8L10 13V19C10 25.075 15.16 30.64 20 32C24.84 30.64 30 25.075 30 19V13L20 8Z"
                          stroke="#E5E7EB"
                          strokeWidth="2"
                        />
                        <path
                          d="M16 20L18.5 22.5L24 17"
                          stroke="#E5E7EB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="trust-security-content">
                      <h3 className="trust-security-title">
                        Restricted Access Controls
                      </h3>
                      <p className="trust-security-description">
                        Access is limited to authorized systems and personnel only
                        via strict IAM policies.
                      </p>
                    </div>
                  </div>

                  {/* Security Item 4 */}
                  <div className="trust-security-item">
                    <div className="trust-security-icon">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 20H12L16 10L24 30L28 20H34"
                          stroke="#E5E7EB"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="trust-security-content">
                      <h3 className="trust-security-title">
                        Continuous Monitoring
                      </h3>
                      <p className="trust-security-description">
                        Security systems are continuously monitored for anomalies
                        and threats.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Platform Policy Compliance Section */}
          <section className="trust-platform-section">
            <div className="trust-platform-container">
              <h2 className="trust-section-title">
                Platform Policy Compliance
              </h2>
              <p className="trust-platform-subtitle">
                Revexia operates within the rules of the platforms it integrates
                with.
              </p>

              <div className="trust-platform-grid">
                {/* Platform 1 */}
                <div className="trust-platform-card">
                  <div className="trust-platform-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="6"
                        y="6"
                        width="20"
                        height="20"
                        rx="4"
                        stroke="#3B82F6"
                        strokeWidth="2"
                      />
                      <path
                        d="M12 12H20M12 16H20M12 20H16"
                        stroke="#3B82F6"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <h3 className="trust-platform-title">
                    Meta & Instagram Rules
                  </h3>
                  <p className="trust-platform-description">
                    Revexia follows Meta and Instagram platform policies.
                  </p>
                </div>

                {/* Platform 2 */}
                <div className="trust-platform-card">
                  <div className="trust-platform-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="16" cy="16" r="10" stroke="#3B82F6" strokeWidth="2" />
                      <path
                        d="M16 12V16L19 19"
                        stroke="#3B82F6"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <h3 className="trust-platform-title">Facebook Messaging</h3>
                  <p className="trust-platform-description">
                    Messaging behavior complies with guidelines.
                  </p>
                </div>

                {/* Platform 3 */}
                <div className="trust-platform-card">
                  <div className="trust-platform-icon">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 6H24C25.1046 6 26 6.89543 26 8V24C26 25.1046 25.1046 26 24 26H8C6.89543 26 6 25.1046 6 24V8C6 6.89543 6.89543 6 8 6H12"
                        stroke="#3B82F6"
                        strokeWidth="2"
                      />
                      <path
                        d="M12 16L15 19L22 12"
                        stroke="#3B82F6"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h3 className="trust-platform-title">
                    Approved Integrations
                  </h3>
                  <p className="trust-platform-description">
                    Only approved and supported DM tools are integrated.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
         <section className="cta-section-final" id="cta">
          <style>{`
            .logo-marquee-wrapper {
              position: relative;
              width: 100%;
              max-width: 100%;
              overflow: hidden;
              margin-top: 48px;
              padding: 16px 0;
            }

            .logo-marquee-track {
              display: flex;
              width: max-content;
              animation: logo-marquee-scroll 30s linear infinite;
              will-change: transform;
            }

            .logo-marquee-group {
              display: flex;
              align-items: center;
              flex-shrink: 0;
            }

            .logo-marquee-item-box {
              width: 160px;
              height: 56px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            }

            .logo-marquee-item {
              height: 36px;
              width: auto;
              max-width: 140px;
              object-fit: contain;
              opacity: 0.85;
              transition: opacity 0.3s ease;
              display: block;
            }

            .logo-marquee-item:hover {
              opacity: 1;
            }

            @keyframes logo-marquee-scroll {
              from {
                transform: translateX(0);
              }
              to {
                transform: translateX(-25%);
              }
            }
          `}</style>

          <div className="container-cta-final">
            {/* Purple Gradient Blur Background */}
            <div className="cta-gradient-blur"></div>
            {/* CTA Content */}
            <div className="cta-content-wrapper">
              {/* Heading Container */}
              <div className="cta-heading-container">
                <h2 className="cta-main-heading">
                  Start Building Your AI Revenue Brain Today.
                </h2>
              </div>
              {/* Subheading Container */}
           
              {/* CTA Buttons */}
              <div className="cta-buttons-wrapper">
                {/* Primary CTA Button - Get Started */}
                
                  <Link to="/auth" className="contact-btn-primary">
                    <span className="cta-button-text">Get started</span>
                   </Link>
                  
             
                {/* Secondary CTA Button - Watch Demo */}
                <button className="cta-button-secondary">
                  {/* Gradient Overlay */}
                  <div className="button-gradient-overlay"></div>
                  {/* Horizontal Divider */}
                  <div className="button-horizontal-divider"></div>
                  {/* Animated Dots */}
                  <div className="button-dot-glow dot-1"></div>
                  <div className="button-dot-normal dot-2"></div>
                  <div className="button-dot-small dot-3"></div>
                  {/* Button Content */}
                  <div className="cta-button-content">
                    <svg
                      className="play-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M3.33325 2L12.6666 8L3.33325 14V2Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="1.33"
                      />
                    </svg>
                    <a
  href="https://www.youtube.com/watch?v=G7D5c40whQA"
  target="_blank"
  rel="noopener noreferrer"
  style={{ color: "black" }}
>
  <span className="cta-button-text-secondary">
    What is Revexia
  </span>
</a>
                  </div>
                </button>
              </div>
              {/* Partner Logos Marquee - Scrolling Ticker */}
              <div className="logo-marquee-wrapper">
                <div className="logo-marquee-track">
                  {[0, 1, 2, 3].map((groupIndex) => (
                    <div
                      className="logo-marquee-group"
                      key={groupIndex}
                      aria-hidden={groupIndex !== 0}
                    >
                      <div className="logo-marquee-item-box">
                        <img
                          src={berlin}
                          alt={groupIndex === 0 ? "Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={esf}
                          alt={groupIndex === 0 ? "European Social Fund" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={hwr}
                          alt={groupIndex === 0 ? "HWR Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={sib}
                          alt={groupIndex === 0 ? "Startup Incubator Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        </main>

        {/* Footer */}
        <footer className="footer-v2" id="contact">
          <div className="container-footer-v2">
            <div className="footer-main-content">
              <div className="footer-brand-section-v2">
                <div className="footer-logo-wrapper">
                  <img
                    src={Logo}
                    alt="Revexia"
                    className="footer-logo-image"
                  />
                </div>
                <p className="footer-brand-description-v2">
                  A platform to turn social media DM engagement into automated
                  revenue with AI-driven personalization.
                </p>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Informations</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  
                </ul>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Social</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a
                      href="https://www.facebook.com/share/1AhWEt4FyM/?mibextid=wwXIfr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/revexia.ai/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                  
                  <li>
                    <a
                      href="https://www.linkedin.com/company/revexiaai/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/revexia.ai"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      TikTok
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Help</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  
                  <li>
                    <Link to="/terms">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                   <li>
                                      <Link to="/facebook-terms">Facebook Terms</Link>
                                    </li>
                </ul>
              </div>
            </div>

            <hr className="footer-divider-line-v2" />

            <div className="footer-bottom-v2">
              <p className="footer-copyright-v2">
                ©2026 Revexia. All rights reserved. Developed by{" "}
                <a
                  href="https://softwarebari.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Softwarebari
                </a>
                .
              </p>
              <div className="footer-legal-links-v2">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <span className="separator-v2">|</span>
                <Link to="/terms">Terms & Conditions</Link>
                <span className="separator-v2">|</span>
                <Link to="/cookies">Cookies Policy</Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default TrustCenterPage;
